import React, { useState } from 'react';
import style from './resourceCircle.module.scss';
import cx from 'classnames';

export default function ResourceCircle(props: {
  className?: string;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
}) {
  const [isMousePressed, setIsMousePressed] = useState(false);

  return (
    <div
      onMouseDown={() => {
        setIsMousePressed(true);

        const listener = () => {
          setIsMousePressed(false);
          document.removeEventListener('mouseup', listener, true);
        };

        document.addEventListener('mouseup', listener, true);
      }}
      className={cx(
        style.container,
        props.className,
        isMousePressed ? style.isPressed : ''
      )}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
}
